'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var separateByDate = function separateByDate(workshops) {
  if (!workshops) return {};
  var byDate = {};
  if (!Array.isArray(workshops)) {
    workshops = Object.keys(workshops).map(function (k) {
      return workshops[k];
    });
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;
  try {
    for (var _iterator = workshops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var workshop = _step.value;
      var startDate = (0, _moment2.default)(workshop.startDate);
      var date = startDate.format("YYYY-MM-DD");
      if (!byDate.hasOwnProperty(date)) byDate[date] = [];
      byDate[date].push(workshop);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;
  try {
    for (var _iterator2 = Object.keys(byDate)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var date = _step2.value;
      byDate[date] = byDate[date].sort(function (w1, w2) {
        // sort by start date
        var startTimeDiff = (0, _moment2.default)(w1.startDate).diff(w2.startDate, 'seconds');
        if (startTimeDiff === 0) {
          // then sort by end date
          var endTimeDiff = (0, _moment2.default)(w1.endDate).diff(w2.endDate, 'seconds');
          if (endTimeDiff === 0) {
            // then sort by name
            return w1.name < w2.name ? -1 : 1;
          }
          return endTimeDiff;
        }
        return startTimeDiff;
      });
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
  return byDate;
};
var filterByCategory = function filterByCategory(workshops, category) {
  if (!category) {
    return workshops;
  }
  if (!Array.isArray(workshops)) {
    workshops = Object.keys(workshops).map(function (k) {
      return workshops[k];
    });
  }
  return workshops.filter(function (workshop) {
    return workshop.workshopCategories.map(function (cat) {
      return cat.id;
    }).indexOf(category) !== -1;
  });
};
var deriveState = function deriveState(props) {
  var categories = props.entities.workshop_categories;
  var byDate = props.entities.workshops && separateByDate(props.entities.workshops);
  var currentDate = byDate && Object.keys(byDate).sort()[0];
  return {
    byDate: byDate,
    currentDate: currentDate,
    categories: categories
  };
};
function manageWorkshopState() {
  return function (WrappedComponent) {
    var Workshops = function (_Component) {
      _inherits(Workshops, _Component);
      function Workshops(props) {
        _classCallCheck(this, Workshops);
        var _this = _possibleConstructorReturn(this, (Workshops.__proto__ || Object.getPrototypeOf(Workshops)).call(this, props));
        _this.setCurrentDate = function (currentDate) {
          return _this.setState({
            currentDate: currentDate
          });
        };
        _this.setCurrentCategory = function (event) {
          var currentCategory = event.target.value;
          var filteredWorkshops = filterByCategory(_this.props.entities.workshops, currentCategory);
          var byDate = separateByDate(filteredWorkshops);
          var currentDate = !!byDate[_this.state.currentDate] ? _this.state.currentDate : Object.keys(byDate)[0];
          _this.setState({
            currentCategory: currentCategory,
            byDate: byDate,
            currentDate: currentDate
          });
        };
        _this.toggleExpanded = function (id) {
          _this.setState(function (_ref) {
            var expanded = _ref.expanded;
            var index = expanded.indexOf(id);
            var newExpanded = expanded.slice();
            if (index > -1) {
              newExpanded.splice(index, 1);
            } else {
              newExpanded.push(id);
            }
            return {
              expanded: newExpanded
            };
          });
        };
        _this.state = _extends({}, deriveState(props), {
          expanded: [],
          currentCategory: ''
        });
        return _this;
      }
      _createClass(Workshops, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          this.setState(deriveState(nextProps));
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state, {
            setCurrentDate: this.setCurrentDate,
            setCurrentCategory: this.setCurrentCategory,
            toggleExpanded: this.toggleExpanded
          }));
        }
      }]);
      return Workshops;
    }(_react.Component);
    return Workshops;
  };
}
exports.default = manageWorkshopState;